// src/data/productsData.js
export const ProductsData = [
  {
    id: 1,
    name: "Tablet Product 1",
    category: "TABLETS",
    image: "assets/images/Olympia_IMG/Tablets-Anadrol.png",
    strength: "250mg/ml",
    dosage: "500mg - 750mg/week",
    packaging: "10 ml vial",
    description: "Used for performance enhancement and strength.",
    additional: {
      strength: "250mg/ml",
      dose: "500-750mg/week",
      packaging: "10ml vial"
    }
  },
  {
    id: 2,
    name: "Tablet Product 2",
    category: "TABLETS",
    image: "assets/images/Olympia_IMG/Tablets-ANAVAR-10.png",
    strength: "100mg/ml",
    dosage: "200mg - 400mg/week",
    packaging: "20 ml vial",
    description: "Known for cutting and lean muscle preservation.",
    additional: {
      strength: "100mg/ml",
      dose: "200-400mg/week",
      packaging: "20ml vial"
    }
  },
  {
    id: 3,
    name: "Tablet Product 3",
    category: "TABLETS",
    image: "assets/images/Olympia_IMG/Tablets-CLEN.png",
    strength: "150mg/ml",
    dosage: "300mg - 500mg/week",
    packaging: "15 ml vial",
    description: "Helps in fat loss and maintaining muscle mass.",
    additional: {
      strength: "150mg/ml",
      dose: "300-500mg/week",
      packaging: "15ml vial"
    }
  },
  {
    id: 4,
    name: "Tablet Product 4",
    category: "TABLETS",
    image: "assets/images/Olympia_IMG/Tablets-Dianabol.png",
    strength: "150mg/ml",
    dosage: "300mg - 500mg/week",
    packaging: "15 ml vial",
    description: "Supports muscle growth and strength.",
    additional: {
      strength: "150mg/ml",
      dose: "300-500mg/week",
      packaging: "15ml vial"
    }
  },
  {
    id: 5,
    name: "Tablet Product 5",
    category: "TABLETS",
    image: "assets/images/Olympia_IMG/Tablets-STANA-10.png",
    strength: "150mg/ml",
    dosage: "300mg - 500mg/week",
    packaging: "15 ml vial",
    description: "Aids in lean muscle retention.",
    additional: {
      strength: "150mg/ml",
      dose: "300-500mg/week",
      packaging: "15ml vial"
    }
  },
  {
    id: 6,
    name: "Tablet Product 6",
    category: "TABLETS",
    image: "assets/images/Olympia_IMG/Tablets-T3-50.png",
    strength: "150mg/ml",
    dosage: "300mg - 500mg/week",
    packaging: "15 ml vial",
    description: "Promotes fat loss and metabolism.",
    additional: {
      strength: "150mg/ml",
      dose: "300-500mg/week",
      packaging: "15ml vial"
    }
  },
  {
    id: 7,
    name: "Injectable Product 1",
    category: "INJECTABLES",
    image: "assets/images/Olympia_IMG/Inject-BULK.png",
    strength: "300mg/ml",
    dosage: "400mg - 600mg/week",
    packaging: "10 ml vial",
    description: "Supports testosterone enhancement and recovery.",
    additional: {
      strength: "300mg/ml",
      dose: "400-600mg/week",
      packaging: "10ml vial"
    }
  },
  {
    id: 8,
    name: "Injectable Product 2",
    category: "INJECTABLES",
    image: "assets/images/Olympia_IMG/Inject-CUT.png",
    strength: "300mg/ml",
    dosage: "400mg - 600mg/week",
    packaging: "10 ml vial",
    description: "Aids in cutting and muscle definition.",
    additional: {
      strength: "300mg/ml",
      dose: "400-600mg/week",
      packaging: "10ml vial"
    }
  },
  {
    id: 9,
    name: "Injectable Product 3",
    category: "INJECTABLES",
    image: "assets/images/Olympia_IMG/Inject-EQ.png",
    strength: "300mg/ml",
    dosage: "400mg - 600mg/week",
    packaging: "10 ml vial",
    description: "Enhances endurance and muscle growth.",
    additional: {
      strength: "300mg/ml",
      dose: "400-600mg/week",
      packaging: "10ml vial"
    }
  },
  {
    id: 10,
    name: "Injectable Product 4",
    category: "INJECTABLES",
    image: "assets/images/Olympia_IMG/Inject-Primabolan.png",
    strength: "50mcg/vial",
    dosage: "100mcg - 200mcg/day",
    packaging: "10 vials pack",
    description: "Promotes lean muscle mass.",
    additional: {
      strength: "50mcg/vial",
      dose: "100-200mcg/day",
      packaging: "10 vials pack"
    }
  },
  {
    id: 11,
    name: "Injectable Product 5",
    category: "INJECTABLES",
    image: "assets/images/Olympia_IMG/Inject-DECA.png",
    strength: "50mcg/vial",
    dosage: "100mcg - 200mcg/day",
    packaging: "10 vials pack",
    description: "Supports joint health and muscle growth.",
    additional: {
      strength: "50mcg/vial",
      dose: "100-200mcg/day",
      packaging: "10 vials pack"
    }
  },
  {
    id: 12,
    name: "Injectable Product 6",
    category: "INJECTABLES",
    image: "assets/images/Olympia_IMG/Inject-MasterP.png",
    strength: "50mcg/vial",
    dosage: "100mcg - 200mcg/day",
    packaging: "10 vials pack",
    description: "Enhances muscle hardness and definition.",
    additional: {
      strength: "50mcg/vial",
      dose: "100-200mcg/day",
      packaging: "10 vials pack"
    }
  },
  {
    id: 13,
    name: "Injectable Product 7",
    category: "INJECTABLES",
    image: "assets/images/Olympia_IMG/Inject-Sustanon.png",
    strength: "50mcg/vial",
    dosage: "100mcg - 200mcg/day",
    packaging: "10 vials pack",
    description: "Boosts testosterone levels.",
    additional: {
      strength: "50mcg/vial",
      dose: "100-200mcg/day",
      packaging: "10 vials pack"
    }
  },
  {
    id: 14,
    name: "Injectable Product 8",
    category: "INJECTABLES",
    image: "assets/images/Olympia_IMG/Inject-TestC.png",
    strength: "50mcg/vial",
    dosage: "100mcg - 200mcg/day",
    packaging: "10 vials pack",
    description: "Supports muscle growth and recovery.",
    additional: {
      strength: "50mcg/vial",
      dose: "100-200mcg/day",
      packaging: "10 vials pack"
    }
  },
  {
    id: 15,
    name: "Injectable Product 9",
    category: "INJECTABLES",
    image: "assets/images/Olympia_IMG/Inject-TestE.png",
    strength: "50mcg/vial",
    dosage: "100mcg - 200mcg/day",
    packaging: "10 vials pack",
    description: "Enhances testosterone and strength.",
    additional: {
      strength: "50mcg/vial",
      dose: "100-200mcg/day",
      packaging: "10 vials pack"
    }
  },
  {
    id: 16,
    name: "Injectable Product 10",
    category: "INJECTABLES",
    image: "assets/images/Olympia_IMG/Inject-TestP.png",
    strength: "50mcg/vial",
    dosage: "100mcg - 200mcg/day",
    packaging: "10 vials pack",
    description: "Promotes rapid testosterone boost.",
    additional: {
      strength: "50mcg/vial",
      dose: "100-200mcg/day",
      packaging: "10 vials pack"
    }
  },
  {
    id: 17,
    name: "Injectable Product 11",
    category: "INJECTABLES",
    image: "assets/images/Olympia_IMG/Inject-TREN_A.png",
    strength: "50mcg/vial",
    dosage: "100mcg - 200mcg/day",
    packaging: "10 vials pack",
    description: "Supports muscle growth and fat loss.",
    additional: {
      strength: "50mcg/vial",
      dose: "100-200mcg/day",
      packaging: "10 vials pack"
    }
  },
  {
    id: 18,
    name: "Injectable Product 12",
    category: "INJECTABLES",
    image: "assets/images/Olympia_IMG/Inject-TREN_H.png",
    strength: "50mcg/vial",
    dosage: "100mcg - 200mcg/day",
    packaging: "10 vials pack",
    description: "Enhances muscle definition and strength.",
    additional: {
      strength: "50mcg/vial",
      dose: "100-200mcg/day",
      packaging: "10 vials pack"
    }
  },
  {
    id: 19,
    name: "Injectable Product 13",
    category: "INJECTABLES",
    image: "assets/images/Olympia_IMG/Inject-TREN_MIX.png",
    strength: "50mcg/vial",
    dosage: "100mcg - 200mcg/day",
    packaging: "10 vials pack",
    description: "Combines multiple trenbolone esters for enhanced effects.",
    additional: {
      strength: "50mcg/vial",
      dose: "100-200mcg/day",
      packaging: "10 vials pack"
    }
  },
  {
    id: 20,
    name: "Injectable Product 14",
    category: "INJECTABLES",
    image: "assets/images/Olympia_IMG/Inject-TrenE.png",
    strength: "50mcg/vial",
    dosage: "100mcg - 200mcg/day",
    packaging: "10 vials pack",
    description: "Promotes muscle growth and recovery.",
    additional: {
      strength: "50mcg/vial",
      dose: "100-200mcg/day",
      packaging: "10 vials pack"
    }
  },
  {
    id: 21,
    name: "Injectable Product 15",
    category: "INJECTABLES",
    image: "assets/images/Olympia_IMG/Inject-WINSTROL.png",
    strength: "50mcg/vial",
    dosage: "100mcg - 200mcg/day",
    packaging: "10 vials pack",
    description: "Enhances muscle definition and performance.",
    additional: {
      strength: "50mcg/vial",
      dose: "100-200mcg/day",
      packaging: "10 vials pack"
    }
  },
  {
    id: 22,
    name: "Peptide Product 1",
    category: "PEPTIDES",
    image: "assets/images/Olympia_IMG/Peptides-FRAG.png",
    strength: "50mcg/vial",
    dosage: "100mcg - 200mcg/day",
    packaging: "10 vials pack",
    description: "Used for fat loss and recovery.",
    additional: {
      strength: "50mcg/vial",
      dose: "100-200mcg/day",
      packaging: "10 vials pack"
    }
  },
  {
    id: 23,
    name: "Peptide Product 2",
    category: "PEPTIDES",
    image: "assets/images/Olympia_IMG/Peptides-GRP6.png",
    strength: "50mcg/vial",
    dosage: "100mcg - 200mcg/day",
    packaging: "10 vials pack",
    description: "Promotes growth hormone release.",
    additional: {
      strength: "50mcg/vial",
      dose: "100-200mcg/day",
      packaging: "10 vials pack"
    }
  },
  {
    id: 24,
    name: "Peptide Product 3",
    category: "PEPTIDES",
    image: "assets/images/Olympia_IMG/Peptides-HGH.png",
    strength: "50mcg/vial",
    dosage: "100mcg - 200mcg/day",
    packaging: "10 vials pack",
    description: "Supports muscle growth and anti-aging.",
    additional: {
      strength: "50mcg/vial",
      dose: "100-200mcg/day",
      packaging: "10 vials pack"
    }
  },
  {
    id: 25,
    name: "Peptide Product 4",
    category: "PEPTIDES",
    image: "assets/images/Olympia_IMG/Peptides-IGF.png",
    strength: "50mcg/vial",
    dosage: "100mcg - 200mcg/day",
    packaging: "10 vials pack",
    description: "Enhances muscle growth and recovery.",
    additional: {
      strength: "50mcg/vial",
      dose: "100-200mcg/day",
      packaging: "10 vials pack"
    }
  }
];